import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null,
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-black flex items-center justify-center p-6">
          <div className="max-w-md bg-zinc-950 border border-red-900/50 rounded-xl p-8">
            <h1 className="text-xl font-semibold text-white mb-4">Something went wrong</h1>
            <p className="text-zinc-400 mb-4">
              An error occurred while loading the application.
            </p>
            {this.state.error && (
              <details className="mb-4">
                <summary className="text-zinc-500 text-sm cursor-pointer mb-2">
                  Error details
                </summary>
                <pre className="text-xs text-zinc-600 bg-zinc-900 p-3 rounded overflow-auto max-h-40">
                  {this.state.error.toString()}
                </pre>
              </details>
            )}
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-zinc-800 text-white rounded hover:bg-zinc-700"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

